<template>
  <b-container id="form" fluid>
    <form>
      <b-row class="px-3">
        <!--            <div class="select-box">-->
        <b-col cols="auto" class="my-2">
          <datepicker
            v-model="filter.dateOne"
            :minimum-view="'month'"
            format="MMM yyyy"
            input-class="date-box form-control"
            style="width: 200px;"
            @input="filters(filter)"
          />
        </b-col>
        <!--                <multiselect-->
        <!--                    :tabindex="-1"-->
        <!--                    v-model="filter.direction"-->
        <!--                    :options="direction"-->
        <!--                    label="direction"-->
        <!--                    track-by="id"-->
        <!--                    selectLabel=""-->
        <!--                    deselectLabel="✖"-->
        <!--                    selectedLabel=""-->
        <!--                    placeholder="เส้นทางวิ่ง"-->
        <!--                    @close="filters(filter)"-->
        <!--                ></multiselect>-->
        <!--            </div>-->
        <b-col
          cols="auto"
          v-if="documentSelected !== 5"
          class="hospital-select-box my-2"
        >
          <multiselect
            v-model="filter.hospital"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="hospitals"
            label="name"
            track-by="id"
            select-label=""
            deselect-label="✖"
            selected-label=""
            placeholder="สถานพยาบาล"
            @close="filters(filter)"
          />
        </b-col>
        <!--            <div >-->

        <!--                <div class="select-box">-->
        <!--                    <div-->
        <!--                        class="datepicker-trigger input-group"-->
        <!--                        @mouseover="activeCloseDate = true"-->
        <!--                        @mouseleave="activeCloseDate = false"-->
        <!--                    >-->
        <!--                        <input-->
        <!--                            class="form-control border-right-0"-->
        <!--                            type="text"-->
        <!--                            autocomplete="off"-->
        <!--                            id="datepicker-trigger"-->
        <!--                            placeholder="Select dates"-->
        <!--                            :value="formatDates(filter.dateOne, filter.dateTwo)"-->
        <!--                        />-->
        <!--                        <div class="input-group-prepend bg-white">-->
        <!--                            <span-->
        <!--                                class="input-group-text border-left-0 rounded-right bg-white"-->
        <!--                                id="basic-addon1"-->
        <!--                                ><fa-icon-->
        <!--                                    v-show="activeCloseDate"-->
        <!--                                    :icon="['fas', 'times']"-->
        <!--                                    class="icon"-->
        <!--                                    @click="clearDate"-->
        <!--                                />-->
        <!--                            </span>-->
        <!--                        </div>-->

        <!--                        <AirbnbStyleDatepicker-->
        <!--                            :trigger-element-id="'datepicker-trigger'"-->
        <!--                            :mode="'range'"-->
        <!--                            :showShortcutsMenuTrigger="false"-->
        <!--                            :fullscreen-mobile="true"-->
        <!--                            :date-one="filter.dateOne"-->
        <!--                            :date-two="filter.dateTwo"-->
        <!--                            @date-one-selected="-->
        <!--                                val => {-->
        <!--                                    filter.dateOne = val;-->
        <!--                                }-->
        <!--                            "-->
        <!--                            @date-two-selected="-->
        <!--                                val => {-->
        <!--                                    filter.dateTwo = val;-->
        <!--                                }-->
        <!--                            "-->
        <!--                            @apply="filters(filter)"-->
        <!--                        />-->
        <!--                    </div>-->
        <!--                </div>-->
        <!-- <div class="select-box">
                    <datetime
                        input-class="form-control"
                        class="theme-orange"
                        format="dd-MM-yyyy"
                        v-model="filter.endDate"
                        :min-datetime="filter.startDate"
                        placeholder="end date"
                        v-on:keyup.enter="filters(filter)"
                    ></datetime>
                </div> -->
        <!--            </div>-->
        <b-col v-if="documentSelected !== 5" cols="auto">
          <div class="select-box my-2">
            <multiselect
              v-model="filter.paymentStatus"
              style="min-width: 200px;"
              :tabindex="-1"
              :options="getPaymentStatuses"
              label="name"
              track-by="id"
              select-label=""
              deselect-label="✖"
              selected-label=""
              placeholder="สถานะ"
              @close="filters(filter)"
            />
          </div>
        </b-col>
        <b-col cols="auto" class="my-auto">
          <b-form-checkbox v-model="filter.noInvoice" @input="filters(filter)"
            >ไม่มี Invoice</b-form-checkbox
          >
        </b-col>
        <b-col cols="auto" class="my-2">
          <input
            v-model="filter.in"
            type="search"
            class="form-control"
            style="width:200px;"
            placeholder="เลขที่เอกสาร"
            @input="filter.in === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="my-auto">
          <div class="search-icon" @click="filters(filter)">
            <fa-icon icon="search" />
          </div>
        </b-col>
      </b-row>
    </form>
  </b-container>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters, mapActions } from "vuex";
import format from "date-fns/format";
import Datepicker from "vuejs-datepicker";

export default {
  name: "FullSearchFilter",
  components: {
    Datepicker,
  },
  props: {
    firstFilter: {
      type: Object,
    },
    filters: {
      type: Function,
    },
    hospitals: {
      type: Array,
    },
    documentSelected: {},
  },
  computed: {
    ...mapGetters({
      direction: "Direction/getAll",
      getPaymentStatuses: "Account/getPaymentStatuses",
      getFilter: "Account/getFilter",
      // hospital: "Hospital/getAll"
    }),
    filter: {
      get() {
        return this.getFilter;
      },
      set(value) {
        this.setFilter(value);
      },
    },
  },
  async mounted() {
    await this.setDirection();
    if (this.firstFilter) {
      this.hospitalOption = this.hospital;
      // this.filter = this.firstFilter;
      let today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
      if (!this.filter.dateOne) {
        this.filter.dateOne = today;
      }
      // document.getElementById("datepicker-trigger").value = format(
      //     today,
      //     this.dateFormat
      // );

      this.filters(this.filter);
    }
  },
  data() {
    return {
      activeCloseDate: false,
      dateFormat: "D/MM/YYYY",
    };
  },
  methods: {
    ...mapActions({
      filterOrder: "Order/filterData",
      setDirection: "Direction/setAll",
      setFilter: "Account/setFilter",
    }),
    // filters(obj) {
    //     let val = {};
    //     if (obj.dateTwo === "") {
    //         val = {
    //             page_no: obj.page_no != null ? obj.page_no : "1",
    //             direction_id: obj.direction != null ? obj.direction.id : "",
    //             hospital_id: obj.hospital != null ? obj.hospital.id : "",
    //             owner_name: obj.owner_name != null ? obj.owner_name : "",
    //             pet_name: obj.pet_name != null ? obj.pet_name : "",
    //             hn: obj.hn != null ? obj.hn : "",
    //             start_date: obj.dateOne
    //                 ? moment(obj.dateOne).format("YYYY-MM-DD")
    //                 : "",
    //             end_date: obj.dateOne
    //                 ? moment(obj.dateOne).format("YYYY-MM-DD")
    //                 : "",
    //             status_id: "2,3,4,5,6,7",
    //             receive: true
    //         };
    //     } else {
    //         val = {
    //             page_no: obj.page_no != null ? obj.page_no : "1",
    //             direction_id: obj.direction != null ? obj.direction.id : "",
    //             hospital_id: obj.hospital != null ? obj.hospital.id : "",
    //             owner_name: obj.owner_name != null ? obj.owner_name : "",
    //             pet_name: obj.pet_name != null ? obj.pet_name : "",
    //             hn: obj.hn != null ? obj.hn : "",
    //             start_date: obj.dateOne
    //                 ? moment(obj.dateOne).format("YYYY-MM-DD")
    //                 : "",
    //             end_date: obj.dateTwo
    //                 ? moment(obj.dateTwo).format("YYYY-MM-DD")
    //                 : "",
    //             status_id: "2,3,4,5,6,7",
    //             receive: true
    //         };
    //     }
    //     this.filterOrder(val);
    // },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearDate() {
      this.filter.dateOne = "";
      this.filter.dateTwo = "";
      this.filters(this.filter);
    },
  },
};
</script>

<style lang="scss" scoped>
/*.date-box {*/
/*    display: flex;*/
/*    flex-direction: row;*/
/*    justify-content: center;*/
/*    align-items: center;*/
/*    width: 15.5vw;*/
/*}*/

.icon {
  cursor: pointer;
}
#form {
  background-color: #eaeced;
  padding: 5px;
  /* margin-left: 1px;
  margin-right: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 50px; */
}
.left {
  text-align: left;
}
.search-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.search {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
input[type="search"] {
  margin-left: 5px;
  width: 22%;
}
.select-box {
  margin: 0px 5px 0px 5px;
  width: 20vw;
}

.hospital-select-box {
  min-width: 30vw;
  margin: 0px 5px 0px 5px;
}

.search-icon {
  align-self: center;
  margin: 0px 0px 0px 10px;
}
.flex {
  display: flex;
  margin-right: 10px;
  margin-left: 5px;
}
a {
  color: black;
  cursor: pointer;
}
</style>

<style>
.date-box {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
}
</style>
